import { PageProps, graphql } from "gatsby";

import { LocalType } from "../models/localType";
import React from "react";
import ReactMarkdown from "react-markdown";
import SEO from "../components/Seo";
import { SEOArguments } from "../classes/seoArguments";
import { usePageLocalization } from "@sbi-international/boutik.gatsby.plugin.multilocale";
import MainLayout from "../components/layout/MainLayout";

export const query = graphql`
    query ArticleTemplate($code: String!) {
        articles: allProductsJson(
            filter: { category: { eq: "/Century/CMS/Blog/" }, code: { eq: $code } }
        ) {
            nodes {
                category
                code
                title {
                    en_CA
                    en_US
                    fr_CA
                }
                images
                fields {
                    ...productsFieldsImagesFragment
                }
                attributes {
                    blog_subject {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                    content_short {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                    content_wysiwyg {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                    content {
                        group
                        values {
                            fr_CA
                            en_CA
                            en_US
                        }
                    }
                    meta_title {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                    meta_description {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                }
            }
        }
    }
`;

export default function Article({ data }: PageProps<Queries.ArticleTemplateQuery>) {
    const article = data.articles.nodes[0];
    const currentLocale = usePageLocalization().currentLocale as keyof LocalType;
    const articleContent = article?.attributes?.content;
    const articleContentWysiwyg = article?.attributes?.content_wysiwyg;
    let count = -1; // Compteur pour afficher les images en ordres

    let content = String(
        articleContentWysiwyg
            ? articleContentWysiwyg?.values?.[0]?.[currentLocale]
            : articleContent?.values?.[0]?.[currentLocale]
    );

    const images = article?.fields?.images as any[];

    if (content) {
        content = content.replace(/(!\[.*?\]\()(.+?)(\))/g, function (whole, a, b, c) {
            count++;
            return article?.fields?.images
                ? `${a}${images[count]?.childImageSharp?.gatsbyImageData?.images?.fallback.src}${c}`
                : "";
        });
    }

    const seoArguments = new SEOArguments(data.articles, currentLocale as keyof LocalType);

    return (
        <MainLayout>
            <SEO title={seoArguments.title} description={seoArguments.description} />
            <div className="container">
                <div className="row article">
                    <div id="primary">
                        <div>
                            <h1>{article?.title?.[currentLocale]}</h1>

                            {articleContentWysiwyg ? (
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: content,
                                    }}
                                />
                            ) : (
                                <ReactMarkdown>{content}</ReactMarkdown>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </MainLayout>
    );
}
